import { createWatcherFn, version, WatcherTypeFn } from 'rewire-core';
import { Form, IFormContext }                      from 'rewire-ui';
import { UdfDocumentType, IUdf }                   from '../DataTypes';
import udfsSubscriptionService                     from '../services/UdfsSubscriptionService';
import FilterDialogModel                           from '../utility/FilterDialogModel';
import CustomFilterModel, {
  IPropertyMapField,
  getPropertyMapFieldsFromUdfs,
}                                                  from '../utility/CustomFilterModel';

export default abstract class CustomFilterDialogModel<TState = unknown> extends FilterDialogModel<TState> {
  customFilterModel: CustomFilterModel;
  protected watchUdfs: WatcherTypeFn;

  protected constructor(title: string, protected basePropertyMapFields: IPropertyMapField[], protected udfDocumentTypes: UdfDocumentType[] = [], protected udfPropertyMapFieldEnhancer: ((propertyMapField: IPropertyMapField, udf: IUdf) => void) | undefined = undefined, protected propertyMapFieldsMapper: ((propertyMapFields: IPropertyMapField[]) => IPropertyMapField[]) | undefined = undefined) {
    super(title);

    let propertyMapFields = this.basePropertyMapFields;
    if (this.propertyMapFieldsMapper) {
      propertyMapFields = this.propertyMapFieldsMapper(propertyMapFields);
    }

    this.customFilterModel = new this.CustomFilterModelClass(propertyMapFields, this.form);

    if (udfDocumentTypes.length) {
      this.watchUdfs = createWatcherFn();
      this.watchUdfs(() => { version(udfsSubscriptionService.subscriptionModel.udfs); }, () => {
        this.calculateCurrentUdfs();
      });
    }
  }

  get CustomFilterModelClass() {
    return CustomFilterModel;
  }

  get propertyMap() {
    return this.customFilterModel.propertyMap;
  }

  protected calculateCurrentUdfs() {
    const currUdfs             = udfsSubscriptionService.subscriptionModel.getUdfs({documentType: this.udfDocumentTypes});
    const udfPropertyMapFields = getPropertyMapFieldsFromUdfs(currUdfs, this.udfPropertyMapFieldEnhancer);
    let propertyMapFields      = [...this.basePropertyMapFields, ...udfPropertyMapFields];
    if (this.propertyMapFieldsMapper) {
      propertyMapFields = this.propertyMapFieldsMapper(propertyMapFields);
    }
    this.customFilterModel.generatePropertyMap(propertyMapFields);
  }

  protected async _load(filters?: ObjectType): Promise<void> {
    await this.customFilterModel.load(filters?.custom);
  }

  _reset(defaultObj?: any) {
    super._reset(defaultObj);
    this.customFilterModel.reset(false);
  }

  protected hasChanges(): boolean {
    return super.hasChanges() || true;
  }

  protected hasCustomFilterErrors(): boolean {
    return this.customFilterModel.hasErrors();
  }

  protected _createForm(): Form {
    return Form.create((_ctx: IFormContext) => ({}), {}, { variant: 'outlined', initialValuesValidationMode: 'none' });
  }

  protected mapToSave(): ObjectType {
    return ({
      custom: this.customFilterModel.mapToSave(),
    });
  }
}
